export default "__VITE_ASSET__DCqaSHwk__"